export default "__VITE_ASSET__Dppa288x__"